document.addEventListener("DOMContentLoaded", function () {

  const root = document.querySelector("[data-fs-root]");

  if (!root) return;

  const drawer =
    root.querySelector("[data-fs-drawer]");

  const items =
    root.querySelector("[data-fs-cart-items]");

  const count =
    root.querySelector("[data-fs-count]");

  const total =
    root.querySelector("[data-fs-total]");

  const toast =
    root.querySelector("[data-fs-toast]");

  let cart = [];


  /* =========================
     FORMATARE PREȚ
  ========================= */

  function money(number) {

    return new Intl.NumberFormat(
      "ro-RO",
      {
        style: "currency",
        currency: "RON"
      }
    ).format(number);

  }


  /* =========================
     AFISARE COS
  ========================= */

  function renderCart() {

    const quantity = cart.reduce(
      function (sum, product) {
        return sum + product.qty;
      },
      0
    );

    count.textContent = quantity;


    const cartTotal = cart.reduce(
      function (sum, product) {

        return sum +
          product.price *
          product.qty;

      },
      0
    );


    total.textContent =
      money(cartTotal);


    if (!cart.length) {

      items.innerHTML =
        "<p class='fs-small'>Coșul este gol. Alege un ritual.</p>";

      return;

    }


    items.innerHTML = cart
      .map(function (product, index) {

        return `
          <div class="fs-cart-item">

            <span>
              ${product.name}
              <br>

              <small>
                ${product.qty}
                ×
                ${money(product.price)}
              </small>

            </span>

            <button
              class="fs-close"
              data-remove="${index}"
              aria-label="Șterge produs"
            >
              ×
            </button>

          </div>
        `;

      })
      .join("");

  }


  /* =========================
     DESCHIDE COS
  ========================= */

  function openCart() {

    drawer.classList.add("open");

    drawer.setAttribute(
      "aria-hidden",
      "false"
    );

  }


  /* =========================
     INCHIDE COS
  ========================= */

  function closeCart() {

    drawer.classList.remove("open");

    drawer.setAttribute(
      "aria-hidden",
      "true"
    );

  }


  root
    .querySelectorAll("[data-fs-open-cart]")
    .forEach(function (button) {

      button.addEventListener(
        "click",
        openCart
      );

    });


  root
    .querySelectorAll("[data-fs-close-cart]")
    .forEach(function (button) {

      button.addEventListener(
        "click",
        closeCart
      );

    });


  /* =========================
     ADAUGARE PRODUSE
  ========================= */

  root.addEventListener(
    "click",
    function (event) {

      const button =
        event.target.closest(
          "[data-fs-add]"
        );


      if (button) {

        const id =
          button.dataset.id;

        const name =
          button.dataset.name;

        const price =
          Number(
            button.dataset.price
          );


        const existing =
          cart.find(
            function (product) {
              return product.id === id;
            }
          );


        if (existing) {

          existing.qty++;

        } else {

          cart.push({
            id: id,
            name: name,
            price: price,
            qty: 1
          });

        }


        renderCart();

        openCart();


        toast.classList.add(
          "show"
        );


        setTimeout(
          function () {

            toast.classList.remove(
              "show"
            );

          },
          1300
        );

      }


      /* =========================
         STERGERE PRODUS
      ========================= */

      const removeButton =
        event.target.closest(
          "[data-remove]"
        );


      if (removeButton) {

        const index =
          Number(
            removeButton.dataset.remove
          );


        cart.splice(
          index,
          1
        );


        renderCart();

      }

    }
  );


  /* =========================
     FAQ
  ========================= */

  root
    .querySelectorAll(".fs-faq-q")
    .forEach(function (question) {

      question.addEventListener(
        "click",
        function () {

          question
            .parentElement
            .classList
            .toggle("open");

        }
      );

    });


  /* =========================
     CHECKOUT SHOPIFY
  ========================= */

  const checkoutButton =
    root.querySelector(
      "[data-fs-checkout]"
    );


  if (checkoutButton) {

    checkoutButton.addEventListener(
      "click",
      async function () {

        if (!cart.length) {

          return;

        }


        try {

          for (
            const product of cart
          ) {

            await fetch(
              "/cart/add.js",
              {
                method: "POST",

                headers: {
                  "Content-Type":
                    "application/json"
                },

                body:
                  JSON.stringify({
                    id: product.id,
                    quantity: product.qty
                  })
              }
            );

          }


          window.location.href =
            "/checkout";

        }

        catch (error) {

          window.location.href =
            "/cart";

        }

      }
    );

  }


  renderCart();

});